import { render, staticRenderFns } from "./ActivateFormationEndButton.vue?vue&type=template&id=3564a9f8&scoped=true&"
import script from "./ActivateFormationEndButton.vue?vue&type=script&lang=js&"
export * from "./ActivateFormationEndButton.vue?vue&type=script&lang=js&"
import style0 from "./ActivateFormationEndButton.vue?vue&type=style&index=0&id=3564a9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564a9f8",
  null
  
)

export default component.exports